const defaultMessage = `The Content-Range header is missing in the HTTP Response. 
The simple REST data provider expects responses for lists of resources to contain this 
header with the total number of results to build the pagination. If you are using CORS, 
did you declare Content-Range in the Access-Control-Expose-Headers header?`;

export class ContentRangeError extends Error {
    constructor(message = defaultMessage) {
        super(message);
    }
}
